import axios from "@/services/api/utils/interceptors";

export default (phone: string, password: string): Promise<any> => {
  const url = `/api/auth/login`;
  return axios.post(url, { phone, password });
};
